export default __webpack_public_path__ + "static/media/640_dummy2016-weinhandel01-mobile-de.c4df5b70.png";